export interface TokenResponse {
  id_token: string;
  access_token: string;
  token_type: string;
  expires_in: number;
  user_status_flag: UserStatusFlag.Ok | UserStatusFlag.InactiveLimitedAccess;
}

export enum UserStatusFlag {
  Ok,
  InactiveLimitedAccess
}
